
export const filterTypes = {
    TEXT: 'TEXT',
    SELECT: 'SELECT',
    DATE: 'DATE'
};
